const getUsers = (build) =>
  build.query({
    query: ({
      pageIndex = 0,
      pageSize = 10,
      search = "",
      sorting = [],
      whiteLabel = "",
    } = {}) => {
      const params = new URLSearchParams({
        limit: pageSize.toString(),
        page: (pageIndex + 1).toString(),
      });

      if (search) params.append("search", search);
      if (sorting?.length > 0) {
        params.append("sortBy", sorting[0].id);
        params.append("sortOrder", sorting[0].desc ? "desc" : "asc");
      }

      if (whiteLabel) params.append("whiteLabel", whiteLabel);

      return {
        url: `/superadmin/paginated?${params.toString()}`,
        method: "GET",
      };
    },
    providesTags: (result) => [
      { type: "Users", id: "LIST" },
      ...(result?.users || []).map((user) => ({ type: "User", id: user.uid })),
    ],
    transformResponse: (response) => ({
      users: response.users || [],
      pageInfo: response.pageInfo || {
        totalCount: 0,
        currentPage: 1,
        totalPages: 1,
      },
    }),
  });
export default getUsers;
